"use client"
import { Typography } from "antd";
import { motion } from "framer-motion";
import Seo, { siteBase } from "../components/Seo";
import "./PrivacyPolicy.css";

const { Title, Text } = Typography;

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      <Seo
        title="Privacy Policy"
        description="How Tanaka Life collects, uses and protects your personal information when you buy airtime, data bundles and ZESA tokens."
        canonical={`${siteBase}/privacy-policy`}
      />
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <section className="privacy-hero">
          <Title level={1} className="privacy-title">
            Privacy Policy
          </Title>
          <Text className="privacy-subtitle">
            Last Updated: {new Date().toLocaleDateString()}
          </Text>
        </section>

        <section className="privacy-content">
          <div className="privacy-section">
            <Title level={2}>Tanaka Life – Privacy Policy</Title>
            <Text>
              Last Updated: 28/08/2025
              <br /><br />
              At Tanaka Life, your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you use our website and recharge services.
            </Text>
          </div>

          <div className="privacy-section">
            <Title level={2}>1. Information We Collect</Title>
            <Text>
              We may collect the following information when you use our services:
              <br /><br />
              Personal details: Name, email address, phone number, billing information.
              <br /><br />
              Transaction details: Payment confirmations, recharge numbers, electricity meter/account numbers, voucher details.
              <br /><br />
              Technical information: IP address, browser type, device information, and cookies for website performance and security.
            </Text>
          </div>

          <div className="privacy-section">
            <Title level={2}>2. How We Use Your Information</Title>
            <Text>
              Your information is used to:
              <br />
              - Process your recharges and payments.
              <br />
              - Send you confirmations, receipts, and service updates.
              <br />
              - Improve our website and services.
              <br />
              - Respond to your support requests.
              <br />
              - Comply with legal and regulatory requirements.
            </Text>
          </div>

          <div className="privacy-section">
            <Title level={2}>3. Sharing Your Information</Title>
            <Text>
              We do not sell or trade your personal information.
              <br /><br />
              We may share your information only with:
              <br />
              - Mobile networks, electricity providers, or voucher issuers to complete your transaction.
              <br />
              - Payment processors and banks to handle payments.
              <br />
              - Regulatory authorities when required by law.
            </Text>
          </div>

          <div className="privacy-section">
            <Title level={2}>4. Data Security</Title>
            <Text>
              We use secure systems and encryption to protect your data.
              <br /><br />
              Access to your information is restricted to authorized staff only.
              <br /><br />
              While we take every precaution, no system is 100% secure. You use our services at your own risk.
            </Text>
          </div>

          <div className="privacy-section">
            <Title level={2}>5. Cookies & Website Use</Title>
            <Text>
              Our website uses cookies to improve user experience and analyze traffic.
              <br /><br />
              You can disable cookies in your browser, but some features may not work properly.
            </Text>
          </div>

          <div className="privacy-section">
            <Title level={2}>6. Your Rights</Title>
            <Text>
              You have the right to:
              <br />
              - Request access to the personal data we hold about you.
              <br />
              - Request correction of inaccurate information.
              <br />
              - Request deletion of your information where legally possible.
              <br />
              - Opt out of marketing communications at any time.
            </Text>
          </div>

          <div className="privacy-section">
            <Title level={2}>7. Data Retention</Title>
            <Text>
              We retain your information only as long as needed to provide services, comply with laws, and resolve disputes.
            </Text>
          </div>

          <div className="privacy-section">
            <Title level={2}>8. Third-Party Links</Title>
            <Text>
              Our website may contain links to third-party sites. We are not responsible for their privacy practices. Please review their policies separately.
            </Text>
          </div>

          <div className="privacy-section">
            <Title level={2}>9. Updates to This Policy</Title>
            <Text>
              We may update this Privacy Policy from time to time. Changes will be posted on our website, and continued use of our services means you accept those changes.
            </Text>
          </div>

          <div className="privacy-section">
            <Title level={2}>10. Contact Us</Title>
            <Text>
              If you have questions about this Privacy Policy or your personal data, contact us at:
              <br />
              Email: privacy@tanaka.co.za
              <br />
              Phone: +27815901227
            </Text>
          </div>
        </section>
      </motion.div>
    </div>
  );
};

export default PrivacyPolicy;